import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { axiosDefaultApi } from 'src/lib/axios';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';


const deleteModel = ({modelId}: {modelId:number}): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Models/DeleteModel/${modelId}`);
};

type QueryFnType = typeof deleteModel;

type UseDeleteModelOptions = {
  modelId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteModel = ({ config }: UseDeleteModelOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
      onError: (error:AxiosError<any>) => {
        if(error.response && error.response.data && error.response.data.message) {
          const responseMessage = error.response?.data.message;
          console.log(responseMessage)
          addNotification(responseMessage.toString(), 500);
          setIsNotificationVisible(true)
        }
        },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllModels"]);
            addNotification(`Ο Τύπος Συσκευής Διαγράφηκε.`, 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: deleteModel,
    })
}